import { SlotRepository } from '../Repositories/SlotRepository';
import { User } from '../../../User/Model/User';
import { calcRemaining, isEndBeforeStart } from './Utils/DateUtil';
import { Slot } from '../../Model/Slot';
import { isSlotOperationRestricted, getRestrictionMessage } from './Utils/TimeRestriction';

export class UpdateSlotUseCase {
  constructor(private repo: SlotRepository) {}

  execute(id: number, dto: Partial<Slot>, current: User) {
    /* ── 시간 제한 체크 ─────────────────────────── */
    if (isSlotOperationRestricted(current, '수정')) {
      throw new Error(getRestrictionMessage('수정', current));
    }

    const isAdmin = current.grade === 'ADMIN';
    const isLimitedAdmin = isAdmin && Boolean(current.is_limited_partner_admin);
    const canEditDates = isAdmin && !isLimitedAdmin;
    const sanitizedDto: Partial<Slot> = { ...dto };

    if (!canEditDates) {
      delete sanitizedDto.start_date;
      delete sanitizedDto.end_date;
    }

    if (Object.keys(sanitizedDto).length === 0) {
      // 원래 DTO에는 필드가 있었는데, 권한이 없어 필터링된 경우
      if (Object.keys(dto).length > 0 && !canEditDates) {
        throw new Error(
          isLimitedAdmin
            ? '제한형 관리자는 시작일·종료일을 변경할 수 없습니다.'
            : '시작일/종료일은 관리자만 수정할 수 있습니다.',
        );
      }
      throw new Error('수정할 내용이 없습니다.');
    }

    // 종료일이 시작일보다 앞설 수 없음 (둘 다 제공된 경우)
    if (
      sanitizedDto.start_date &&
      sanitizedDto.end_date &&
      isEndBeforeStart(sanitizedDto.start_date, sanitizedDto.end_date)
    ) {
      throw new Error('종료일은 시작일보다 이전일 수 없습니다.');
    }

    return this.repo
      .updateSlot(id, sanitizedDto)
      .then(s => ({ ...s, remaining_days: calcRemaining(s.end_date) }));
  }
}
